import { makeRootStyles } from "../../theme/styles";

const useStyles = makeRootStyles(
  {
    wrapper: {
      marginTop: "2rem",
      display: "flex",
      flexDirection: "column",
      alignSelf: "stretch",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      padding: "1.5rem",
      backgroundColor: "#f7f7f7",
      border: "1px solid #cccccc",
      gap: "1rem",
    },
    formField: {
      width: "100%",
      maxWidth: "312px",
      textAlign: "left",
    },
    disclaimer: {
      fontStyle: "italic",
      color: "#999999",
    },
    errorMessage: {
      paddingTop: "0.5rem",
    },
  },
  { name: "N0ReshopOptIn" },
);

export { useStyles };
